import { render, staticRenderFns } from "./PStatisticModal.vue?vue&type=template&id=21514ee6&scoped=true&"
import script from "./PStatisticModal.vue?vue&type=script&lang=js&"
export * from "./PStatisticModal.vue?vue&type=script&lang=js&"
import style0 from "./PStatisticModal.vue?vue&type=style&index=0&id=21514ee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21514ee6",
  null
  
)

export default component.exports